import React, { useState, useEffect } from "react";
import Header from './Header';
import '../Styles/Dpersonales.css';
import Footer from './Footer';
import PayButton from './PayButton';
import tick from '../Icons/tick.png';
import { sendProducts } from '../Helpers/sendProducts';



const Dpersonals = () => {
    const [ envio, setEnvio ] = useState("domicilio");
    const changeValue = (e, field) =>{
        let old = datosCliente
        old[field] = e.target.value
        setDatosCliente(old)
    }
    const changePago = (e) =>{
        switch(e.target.value){
            case 'recoger': {
                let old = datosCliente
                old["formaPago"] = 2
                setDatosCliente(old)
            }
            break
            case 'domicilio': {
                let old = datosCliente
                old["formaPago"] = 1
                setDatosCliente(old)
            }
            break
            case 'efectivo': {
                let old = datosCliente
                old["formaPago"] = 1
                setDatosCliente(old)
            }
            break
            case 'tdom': {
                let old = datosCliente
                old["formaPago"] = 0
                setDatosCliente(old)
            }
            break
            case 'ton': {
                let old = datosCliente
                old["formaPago"] = 4
                setDatosCliente(old)
            }
        }
    }
    const [ datosCliente, setDatosCliente ] = useState({ 
        cp: "",
        nombre: "",
        direccion: "",
        telefono: "",
        email: "",
        formaPago: 1,
        comentarios: ""
     })
    const [ myCheck, setMyCheck ] = useState(false);
    const mountAndGo=()=>{ 
        if(datosCliente["cp"].length != 5 || datosCliente["nombre"] == "" || datosCliente["telefono"].length != 9 || datosCliente["direccion"] == ""){
            if(datosCliente["cp"].length != 5){
                alert("Código postal incorrecto")
            }
            else if (datosCliente["nombre"] == ""){
                alert("Nombre invalido")
            }
            else if (datosCliente["telefono"].length != 9){
                alert("Teléfono invalido")
            }
            else if (datosCliente["direccion"] == ""){
                alert("Direción invalida")
            }
        }
        else{
            const carrazo = localStorage.getItem("carrito");
            const postdata = { postData: { carrito: JSON.parse(carrazo), datosCliente: datosCliente }}
            sendProducts(postdata);
            console.log(carrazo);
            console.log(datosCliente);
            window.location.href = "/thanks"
        }
    }
    return(
        <div className="All">
            <Header className="myheader" title="El Rancho"/>
            <div className="titles">
                <h3 className="Ppago">Proceso de pago</h3>
                <h3 className="Dpersonales">Datos personales</h3>
            </div>
            <div className="myform">
                <form id="pform">
                    <div className="inputholder">
                        <input type="text" placeholder="Nombre *" onChange={(e)=>{changeValue(e, "nombre")}} required/>
                    </div>
                    <div className="inputholder">
                    <input type="text" placeholder="Número de telefono *" onChange={(e)=>{changeValue(e, "telefono")}}/>
                    </div>
                    <div className="inputholder">
                    <select for="Metodo de pago" onChange={(e)=>{setEnvio(e.target.value);changePago(e)}}>
                        <option value="domicilio">Domicilio</option>
                        <option value="recoger">Recoger</option>
                    </select>
                    </div>
                    { envio === "domicilio" &&
                    <div className="">
                        <div className="inputholder">
                        <select for="Metodo de pago" onChange={(e)=>{changePago(e)}}>
                        <option value="efectivo">Efectivo (comentar tipo de billete)</option>
                        <option value="tdom">Tarjeta en domicilio</option>
                        {/*<option value="ton">Tarjeta online</option> */}
                    </select>
                    </div>
                    <div className="inputholder">
                        <input type="text" placeholder="Dirección *" onChange={(e)=>{changeValue(e, "direccion")}}/>
                    </div>
                    <div className="inputholder">
                        <input type="text" placeholder="Código Postal *" onChange={(e)=>{changeValue(e, "cp")}}/>
                    </div>
                    </div>
                    }
                    <div className="inputholder">
                    <input type="email" placeholder="E-mail" onChange={(e)=>{changeValue(e, "email")}}/>
                    </div>
                    <div className="inputholder" id="t-area">
                    <textarea name="comentarios" id="pform" cols="30" rows="10" onChange={(e)=>{changeValue(e, "comentarios")}}>Comentarios: </textarea>
                    </div>
                    <div className="boxcontainer">
                        <input id="checkbox" type="checkbox" onClick={()=>{setMyCheck(!myCheck)}}></input>
                        <p className="politica">He leído y aceptos los <a href="https://www.barelrancho.es/pp" className="terms">terminos<br id="hidden1"></br> y condiciones</a> de la política de <br id="hidden1"></br> privacidad.</p>
                    </div>
                    {
                        myCheck
                        ? 
                        <div className="myButtonPay">
                            <PayButton link='/thanks' img={tick} text="Pagar" myaction={mountAndGo} go={false}/>
                        </div>
                        : <div className="myButtonPay">
                            <p>Rellena los campos obligatorios</p>
                        </div>
                    }
                </form>
            </div>
            <Footer className="dPfooter"/>
        </div>
    )
}

export default Dpersonals;